/*
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/
const ConsultIndex = resolve =>
  require(['../../../views/ConsultIndex'], resolve)
const ConsultExpertList = resolve =>
  require(['../../../views/ConsultExpertList'], resolve)
const ConsultCouponList = resolve =>
  require(['../../../views/ConsultCouponList'], resolve)
const ConsultHotTeacher = resolve =>
  require(['../../../views/ConsultHotTeacher'], resolve)
const ConsultNewTeacher = resolve =>
  require(['../../../views/ConsultNewTeacher'], resolve)
const ConsultTopicList = resolve =>
  require(['../../../views/consult/ConsultTopicList'], resolve)
const ThanksNoteRate = resolve =>
  require(['../../../views/ThanksNoteRate'], resolve)
const OneMinutePsy = resolve =>
  require(['../../../views/OneMinutePsy'], resolve)

//渠道
// const ChannelExpertList = resolve =>
//   require(['../../../views/ChannelExpertList'], resolve)
// 咨询体验需求
const ConsultExperienceList = resolve =>
  require(['../../../views/consult/ConsultExperienceList'], resolve)

// 咨询-咨询频道
export default [
  // 咨询频道
  {
    path: '/consult-index',
    component: ConsultIndex,
    name: 'consult-index'
  },
  {
    path: '/consult-expert-list',
    component: ConsultExpertList,
    name: 'consult-expert-list'
  },
  {
    path: '/consult-topic-list',
    component: ConsultTopicList,
    name: 'consult-topic-list'
  },
  {
    path: '/consult-coupon-list',
    component: ConsultCouponList,
    name: 'consult-coupon-list'
  },
  {
    path: '/consult-hot-teacher',
    component: ConsultHotTeacher,
    name: 'consult-hot-teacher'
  },
  {
    path: '/consult-new-teacher',
    component: ConsultNewTeacher,
    name: 'consult-new-teacher'
  },
  {
    path: '/thanks-note-rate',
    component: ThanksNoteRate,
    name: 'thanks-note-rate'
  },
  {
    path: '/one-minute-psy',
    component: OneMinutePsy,
    name: 'one-minute-psy'
  },
  {
    path: '/channel-expert-list',
    redirect: '/consult-expert-list'
  },
  {
    path: '/consult-experience-list',
    component: ConsultExperienceList,
    name: 'consult-experience-list'
  }
]



// WEBPACK FOOTER //
// ./src/router/page/consult/channel.js